import {Component, Input} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";
import {NgClassType} from "../../../model/common.model";
import {RouterLink} from "@angular/router";
import {RequireClaimsDirective} from "../../../auth/components/require-claims.directive";

@Component({
  selector: 'tenant-id-tag',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    RouterLink,
    RequireClaimsDirective
  ],
  templateUrl: './tenant-id-tag.component.html',
  styleUrl: './tenant-id-tag.component.sass'
})
export class TenantIdTagComponent {
  @Input() tenantId?: string
  @Input() ngClass?: NgClassType
  checkFailed = false
}
